// extracted by mini-css-extract-plugin
export default {"settings":"nav_settings__-2Aul","active":"nav_active__EIpN3"};